// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf9f90fc","455":"29b80f5e","977":"31dc5052"}[chunkId] + ".chunk.js";
};